export default "__VITE_ASSET__CPRmEbtI__"